import createVueApp from '@phoenix/createVueApp';
import WatchComparatorToaster from '@maison/components/watchComparator/WatchComparatorToaster.vue';

const el = document.getElementById('phoenix-watch-comparator-toaster');
if (el) {
  const app = createVueApp({}, false);
  app.component('WatchComparatorToaster', WatchComparatorToaster);
  app.mount(el);
}
